export enum TranslationOption {
  both = 'both',
  original = 'original',
  translation = 'translation',
}

export const translationOptionList = [
  {
    id: TranslationOption.original,
    value: '仅原文',
  },
  {
    id: TranslationOption.translation,
    value: '仅译文',
  },
  {
    id: TranslationOption.both,
    value: '原文+译文'
  },
];